<template>
  <div style="width: 100%; height: 100%">
    <!-- 1. 顶部欢迎 -->
    <Header />

    <!-- 2. 收藏夹 -->
    <QuickLinks />

    <!-- 3. 提醒横幅 -->
    <WarningNotice />

    <!-- 4. 主体两栏布局 (使用 el-row, el-col) -->
    <el-row :gutter="10">
      <!-- 左侧：公告中心 (占 16/24 栅格) -->
      <el-col :span="16">
        <Announcement />
      </el-col>

      <!-- 右侧：APP 下载 (占 8/24 栅格) -->
      <el-col :span="8">
        <AppDownload />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  asyncGetOrganizationTree,
  asyncGetPositionList,
  asyncGetUserAdditionalInformation
} from '@/utils/asyncTools';
import { weakPwd } from '@/utils/validate';
import { apiResetPassword, collectMenu, getProviderNoticeMsg, queryMenu } from '@/api/user';
import { GlobalSetObj } from '@/lang/type/global';
import md5 from 'js-md5';
import { RouterObj } from '@/lang/type/route';
import AppDownload from './component/AppDownload.vue';
import Header from './component/Header.vue';
import QuickLinks from './component/QuickLinks.vue';
import WarningNotice from './component/WarningNotice.vue';
import Announcement from './component/Announcement.vue';

export default {
  name: 'IndexSorting',
  components: {
    Header,
    QuickLinks,
    WarningNotice,
    Announcement,
    AppDownload
  },
  data() {
    return {
      showViewer: false,
      imgArr: [],
      routerObjLang: RouterObj,
      searchMenuList: [],
      menuList: [],
      // 修改密码弹窗
      centerDialogVisible: false,
      ruleForm: {
        newPassword: '', // 新密码
        newPasswordConfirm: '', // 确认新密码
        oldPassword: '', // 旧密码
        userId: this.$store.getters.userId
      },
      rules: {
        oldPassword: [
          { required: true, message: this.$t('changepwd.inputOldPwd'), trigger: ['blur', 'change'] }
        ],
        newPassword: [
          {
            required: true,
            message: this.$t('changepwd.inputNewPwd'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const { oldPassword } = this.ruleForm;
              if (!weakPwd(value)) {
                callback(new Error(this.$t('changepwd.requestedInputCode')));
              } else if (value === oldPassword) {
                callback(new Error(this.$t('changepwd.newCodeNotOldCode')));
              } else {
                callback();
              }
            }
          }
        ],
        newPasswordConfirm: [
          // { required: true, validator: newPasswordConfirmCheck, trigger: 'blur' }
          {
            required: true,
            message: this.$t('changepwd.inputConfirmCode'),
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const { newPassword } = this.ruleForm;
              if (value === '') {
                callback(new Error(this.$t('changepwd.inputConfirmCode')));
                return;
              }
              if (newPassword !== value) {
                callback(new Error('确认密码与新密码不相同'));
                return;
              }
              callback();
            }
          }
        ]
      },
      messageInfoList: {
        normalMessageList: [],
        topMessageList: []
      }
    };
  },
  computed: {
    GlobalSetObj() {
      return GlobalSetObj;
    }
  },
  async created() {
    this.getUserPopupMsg();
    this.openSearchMenu();
    this.childrenSearch();
    this.getProviderNoticeMsgList();
    // 获取基本信息
    const arr = [
      asyncGetUserAdditionalInformation(),
      asyncGetOrganizationTree(),
      asyncGetPositionList()
    ];
    await Promise.all(arr);
    // this.$store.getters.passwordLastModified为年月日时分秒，转换成时间戳大于当前时间戳三十天时做判断
    const passwordLastModified = new Date(this.$store.getters.passwordLastModified).getTime();
    const now = new Date().getTime();
    if (now - passwordLastModified > 30 * 24 * 60 * 60 * 1000) {
      this.centerDialogVisible = true;
    } else {
      this.centerDialogVisible = false;
    }
  },
  methods: {
    normalizeBrandHtml(content) {
      if (!content) {
        return '';
      }
      return content
        .replace(/#409eff/gi, '#00A551')
        .replace(/rgb\(\s*64\s*,\s*158\s*,\s*255\s*\)/gi, 'rgb(0, 165, 81)')
        .replace(/rgba\(\s*64\s*,\s*158\s*,\s*255\s*,/gi, 'rgba(0, 165, 81,');
    },
    // 查看图片
    getImgSrc(e) {
      if (e.target.nodeName !== 'IMG') {
        return;
      }
      this.imgArr = [e.target.src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    // 查询公告
    getProviderNoticeMsgList() {
      getProviderNoticeMsg({
        systemType: 1
      }).then((res) => {
        if (res.code === 200) {
          this.messageInfoList.normalMessageList = res.data?.normalMessageList;
          this.messageInfoList.topMessageList = res.data?.topMessageList;
          this.messageInfoList.normalMessageList.forEach((item) => {
            item.messageContent = this.normalizeBrandHtml(item.msgData).replace(
              /<p>/g,
              '<p style="margin: 0;">'
            );
          });
          this.messageInfoList.topMessageList.forEach((item) => {
            item.messageContent = this.normalizeBrandHtml(item.msgData).replace(
              /<p>/g,
              '<p style="margin: 0;">'
            );
          });
        }
      });
    },
    //  查询收藏夹
    childrenSearch() {
      const data = {
        source: 1,
        userId: this.$store.state.user.id
      };
      this.searchMenuList = [];
      queryMenu(data).then((res) => {
        if (res.code === 200) {
          const arr = res.data.menuTitle.map((item, index) => {
            const obj = this.menuList.find((item1) => item1.title === item);
            if (obj) {
              return obj;
            }
          });
          arr.forEach((item) => {
            if (item) {
              this.searchMenuList.push(item);
            }
          });
        }
      });
    },
    // 点击删除
    delMenu(val) {
      console.log(val, 'delMenu');
      console.log(this.searchMenuList, 'this.searchMenuList');
      const index = this.searchMenuList.findIndex((item) => item.title === val.title);
      console.log(index, 'index');
      if (index !== -1) {
        this.searchMenuList.splice(index, 1);
        const arr = this.searchMenuList.map((item) => item.title);
        console.log(arr, 'arr');
        this.setFavoritesItem(arr);
      }
    },
    toMenu(item) {
      this.$router.push(item.path);
    },
    draggableChange() {
      console.log(this.searchMenuList, 'draggableChange');
      const arr = this.searchMenuList.map((item) => item.title);
      console.log(arr, 'arr');
      this.setFavoritesItem(arr);
    },
    // 设置收藏夹
    setFavoritesItem(arr) {
      const data = {
        source: 1,
        userId: this.$store.state.user.id,
        menuTitle: arr
      };
      collectMenu(data).then((res) => {
        if (res.code === 200) {
          this.childrenSearch();
        }
      });
    },
    // 点击设置收藏夹
    showSetFavoritesItemDialog() {
      this.$refs.favoritesRef.showSetFavoritesItemDialog();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.asyncResetPassword();
      });
    },
    resetForm(formName) {
      this.centerDialogVisible = false;
      this.$refs[formName].resetFields();
      this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
    openSearchMenu() {
      const arr = this.extractRoutes(this.$store.getters.addRoutes);
      // 去到数组第一个
      arr.splice(0, 1);
      arr.forEach((item) => {
        try {
          if (this.$i18n.locale !== 'zh') {
            item.name = this.routerObjLang[item.title].pu;
          } else {
            item.name = this.routerObjLang[item.title].zh;
          }
        } catch (error) {
          console.log(error, 'error');
        }
      });
      this.menuList = arr;
      console.log(arr, 'arr');
    },
    // 递归过滤
    extractRoutes(routes, parentPath = '', result = [], leave = 0) {
      routes.forEach((route) => {
        let currentPath = route.path;
        if (parentPath && currentPath) {
          currentPath = `${parentPath}/${currentPath}`;
        }
        const title = route.meta && route.meta.title;
        const fillterRouter = route.fillterRouter;
        if (title && currentPath && leave > 0) {
          // 判断把一级的路由过滤
          if (fillterRouter !== true) {
            result.push({ title, path: currentPath, leave, fillterRouter });
          }
        }
        if (route.children && route.children.length > 0) {
          this.extractRoutes(route.children, currentPath, result, leave + 1);
        }
      });
      return result;
    },
    /**
     * 设置新密码
     */
    asyncResetPassword() {
      // const { newPassword, oldPassword } = this.ruleForm;
      const newPassword = md5(md5(this.ruleForm.newPassword));
      const oldPassword = md5(md5(this.ruleForm.oldPassword));
      const obj = {
        isVerification: 1, // 是否需要验证旧密码
        newPassword,
        oldPassword,
        id: this.$store.getters.userId
      };
      apiResetPassword(obj)
        .then((data) => {
          if (data.code === 200) {
            return this.$store.dispatch('user/logout');
          }
        })
        .then((data) => {
          this.$notify({
            title: this.$t('changepwd.succeed'),
            message: this.$t('changepwd.loginAgain'),
            type: 'success'
          });
          setTimeout(() => {
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.tips {
  color: #b4b2b2;
  font-size: 12px;
  line-height: 13px;
  display: inline-block;
}

.color-DF303A {
  color: #df303a;
  font-size: 14px;
  font-weight: bold;
}

@import './index.css';
</style>
